export class TreeNode {
    id: string;
    name: string;
    children: TreeNode[];
}


// WEBPACK FOOTER //
// ./src/app/models/TreeNode.ts